// extracted by mini-css-extract-plugin
module.exports = {"arrow":"bobbingArrow_arrow__Bs4GU","bounce":"bobbingArrow_bounce__ynRf_"};